<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title :class="colorTheme">
          <span class="headline white--text text-uppercase">File Assignment</span>
        </v-card-title>
        <v-progress-linear
          v-if="loading"
          :color="colorTheme"
          :indeterminate="true"
          class="ma-0"
        />

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="category"
                    :color="colorTheme"
                    :items="fileCategories"
                    item-text="name"
                    item-value="value"
                    label="Category"
                    @change="onCategoryChange"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-if="files && !loading"
                    v-model="fileName"
                    :items="files"
                    :options="files"
                    item-text="title"
                    item-value="fileName"
                    label="Template"
                  />
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="name"
                    label="Name"
                    :color="colorTheme"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="usage"
                    :color="colorTheme"
                    multiple
                    :items="fileUsages"
                    item-text="name"
                    item-value="value"
                    label="Usage"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            :color="colorTheme"
            flat="flat"
            @click="closeDialog()"
          >
            cancel
          </v-btn>

          <v-btn
            :color="colorTheme"
            flat="flat"
            @click="submit()"
          >
            create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';
import FileCategoriesEnum, {
  FileCategoriesForBondFullEnum,
  FileCategoriesForBondPriipEnum,
  FileCategoriesForBondWibEnum,
  FileCategoriesForEcspEnum,
} from '../../enum/financialProducts/FileCategories';
import { toQueryString } from '@/helpers';
import FileUsagesEnum from '../../enum/financialProducts/FileUsages';
import { FinancialInstrumentsEnum } from '@/enum/financialProducts/FinancialInstruments';

export default {
  name: 'AddFile',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    instrument: {
      type: String,
      required: true,
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
    setUsages: {
      type: Function,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      category: null,
      fileName: null,
      name: null,
      usage: null,
      files: null,
      loading: false,
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  computed: {
    fileCategories() {
      switch (this.instrument) {
        case FinancialInstrumentsEnum.BOND_WIB:
          return Object.values(FileCategoriesForBondWibEnum).sort();
        case FinancialInstrumentsEnum.BOND_FULL:
          return Object.values(FileCategoriesForBondFullEnum).sort();
        case FinancialInstrumentsEnum.BOND_PRIIP:
          return Object.values(FileCategoriesForBondPriipEnum).sort();
        case FinancialInstrumentsEnum.LOAN_ECSP:
          return Object.values(FileCategoriesForEcspEnum).sort();
        default:
          return Object.values(FileCategoriesEnum).sort();
      }
    },
    fileUsages() {
      return Object.keys(FileUsagesEnum).map(key => FileUsagesEnum[key]);
    },
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
  },
  methods: {
    ...mapActions([
      'filesByCategory',
    ]),
    submit() {
      if (this.$refs.form.validate()) {
        if (!this.usage) {
          this.submitAction({
            category: this.category,
            fileName: this.fileName,
            name: this.name,
            usage: this.usage,
          });
        } else {
          Object.keys(this.usage).forEach((item) => {
            this.submitAction({
              category: this.category,
              fileName: this.fileName,
              name: this.name,
              usage: this.usage[item],
            });
          });
        }
        this.setToDefault();
      }
    },
    closeDialog() {
      this.setToDefault();
      this.cancelAction();
    },
    async onCategoryChange() {
      this.loading = true;
      this.file = null;
      await this.filesByCategory(toQueryString({
        category: this.category,
        fWithTemplate: 1,
      }))
        .then((response) => {
          this.files = response;
        })
        .catch(() => {
          this.loading = false;
        });
      this.usage = this.setUsages(this.category);
      this.loading = false;
    },
    setToDefault() {
      this.category = null;
      this.fileName = null;
      this.name = null;
      this.usage = null;
      this.files = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financialProducts/AddFile.vue